import RequestAccessForm from '@/lib/requestAccess/models/RequestAccessForm';
import formFieldNames from '@/lib/requestAccess/models/formFieldNames';

const formUrl = 'https://app.smartsheet.com/b/form/d3d66be298dc4350b523f4c897839758';
class FeedbackForm extends RequestAccessForm {
  constructor() {
    super(formUrl);
    this.title = 'Feedback Form';
  }
}

export default FeedbackForm;
